module.exports = new __parcel__URL__("usa-flag.17bd64d9.svg").toString();